<template>
  <div class="content-header">
    <div class="content-header-box">
      <img src="@/images/header-logo.png" class="header-logo" @click="jumpPlatform('')">
      <div class="header-right">
        <p class="header-buttons" @click="linkTo('/home')">我的数聚</p>
        <el-popover placement="top-end" class="popover-content" :open-delay="200" width="244" trigger="hover" v-if="loginUser && loginUser.id">
          <div :class="{'head-top':true,'member1':membergrade==1,'member2':membergrade==2,'member3':membergrade==3,'member4':membergrade==4,'member5':membergrade==5,'member6':membergrade==6}">
            <img src="@/images/header-cover-icon.png" class="header-cover">
            <div class="title-box" style="margin-left:9px">
              <p class="phone-text" style="font-family: PingFang-SC-Bold;font-weight:bold">{{loginUser.hiddenAccount}}</p>
              <div class="memberIconInfo">
                <img src="@/images/member-icon1.png" v-if="membergrade==1" alt="">
                <img src="@/images/member-icon2.png" v-else-if="membergrade==2" alt="">
                <img src="@/images/member-icon3.png" v-else-if="membergrade==3" alt="">
                <img src="@/images/member-icon4.png" v-else-if="membergrade==4" alt="">
                <img src="@/images/member-icon5.png" v-else-if="membergrade==5" alt="">
                <img src="@/images/member-icon6.png" v-else-if="membergrade==6" alt="">
                <p :class="{'color1':membergrade==1,'color2':membergrade==2,'color3':membergrade==3,'color4':membergrade==4,'color5':membergrade==5,'color6':membergrade==6}">{{membergradeName}}</p>
              </div>
            </div>
          </div>
          <div class="myFunction-Style">
            <div class="myFunction">
              <div class="myFunction-box" @click="linkTo('/product/myProduct')">
                <img src="@/images/productCenter.png" alt="">
                <span class="myFunction-text">产品中心</span>
              </div>
              <div class="myFunction-box">
                <img src="@/images/myTyData.png" alt="">
                <a class="myFunction-text" href="/home" target="_blank">我的数聚</a>
              </div>
              <div class="myFunction-box" @click="linkTo('/message/messageIndex')">
                <img src="@/images/message.png" alt="">
                <p class="notReadNum-box" v-if="notReadNum"><span class="notReadNum-num">{{notReadNum > 99 ? '99' : notReadNum}}</span></p>
                <span class="myFunction-text">消息中心</span>
              </div>
            </div>
          </div>
          <div class="popover-content-list">
            <p class="popover-content-text">手机：<span>{{loginUser.mobile ? loginUser.mobile : '未绑定'}}</span></p>
            <p class="content-bind-btn" v-if="!loginUser.mobile" @click="linkTo('/security/securityManage')">
              去绑定</p>
          </div>
          <div class="popover-content-list">
            <p class="popover-content-text">邮箱：<span>{{loginUser.email ? loginUser.email : '未绑定'}}</span></p>
            <p class="content-bind-btn" v-if="!loginUser.email" @click="linkTo('/security/securityManage')">
              去绑定</p>
          </div>
          <div class="popover-content-list">
            <p class="popover-content-text">类型：<span>{{loginUser.userType === 'company' ? '企业' : loginUser.userType === 'personal' ? '个人' : ''}}</span>
            </p>
            <p class="content-bind-btn" v-if="!loginUser.userType" @click="linkTo('/user/certification')">去认证</p>
          </div>
          <div class="popover-content-list">
            <p class="popover-content-text">实名：<span v-if="loginUser.realNameStatus==3">已实名</span>
            </p>
            <p class="content-bind-btn" v-if="loginUser.realNameStatus!==3" @click="linkTo('/user/certification')">未实名</p>
          </div>
          <div class="popover-btn-box">
            <p @click="linkTo('/user/accountManage')" class="popover-btn"><img src="@/images/popover-account-icon.png" class="popover-icon">账户资料</p>
            <p @click="linkTo('/security/securityManage')" class="popover-btn"><img src="@/images/popover-security-icon.png" class="popover-icon">安全设置</p>
            <p @click="userLogout" class="popover-btn"><img src="@/images/popover-loginout-icon.png" class="popover-icon">退出</p>
          </div>
          <div slot="reference" class="popover-content-box">
            <div class="title-box">
              <span class="phone-text">{{loginUser.hiddenAccount}}<i class="el-icon-arrow-down"></i></span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMemberInfo, logout } from '@/services/home'

export default {
  data () {
    return {
      membergrade: '',
      membergradeName: ''
    }
  },

  mounted () {
    console.log(this.loginUser, this.notReadNum)
    this.getMember()
    if (process.env.SSO_CLIENTS) {
      this.ssoClients = process.env.SSO_CLIENTS.split(',')
    }
  },
  computed: {
    ...mapGetters(['loginUser', 'notReadNum'])
  },

  methods: {
    jumpPlatform (path) {
      let url = process.env.PLATFORM_URL + path
      window.open(url, '_blank')
    },
    linkTo (type) {
      this.$router.push({ path: type })
    },
    getMember () {
      getMemberInfo().then(res => {
        if (res.data.grade !== null) {
          let membergrade = res.data.grade
          res.data.membersGradeList.map((item, index) => {
            if (item.grade == membergrade) {
              this.membergradeName = item.gradeName
              this.membergrade = item.grade
            }
          })
        }
      })
    },

    userLogout () {
      let _this = this
      this.$confirm('确定是否退出登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout().then(() => {
            inner()
            this.$router.push({ path: '/login' })
          })
        })
        .catch(error => {
          console.log(error)
        })

      function inner () {
        _this.$store.commit('updateUserData', {})
      }
    }
  }
}
</script>

<style lang="less">
.content-header {
  height: 72px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .content-header-box {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header-logo {
    cursor: pointer;
  }
  .header-buttons {
    width: 70px;
    height: 30px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #2d73ff;
    color: #2d73ff;
    cursor: pointer;
    font-size: 14px;
    border-radius: 15px;
    font-family: PingFang-SC-Medium;
    margin-right: 18px;
  }
}
.header-right {
  display: flex;
  font-size: 16px;
  align-items: center;
  float: right;
  // margin-right: 23px;
}
.el-popover {
  border-radius: 10px;
  padding: 0;
  .head-top {
    // border-bottom: 1px solid #ebebeb;
    display: flex;
    height: 139px;
    padding: 15px 16px 0 12px;
    box-sizing: border-box;
  }
  .myFunction-Style {
    width: 244px;
    display: flex;
    justify-content: center;
  }
  .myFunction {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background: #fff;
    width: 220px;
    height: 68px;
    margin-top: -78px;
    border-radius: 6px;
    .myFunction-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .myFunction-text {
        color: #333333;
        font-size: 12px;
        font-family: PingFang-SC-Medium;
        margin-top: 5px;
        cursor: pointer;
      }
      .notReadNum-box {
        width: 14px;
        height: 14px;
        display: inline-block;
        background: #fe5200;
        border-radius: 50%;
        color: rgba(255, 255, 255, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0px;
        right: 5px;
      }

      .notReadNum-num {
        font-size: 12px;
        transform: scale(0.8);
        font-family: PingFang-SC-Medium;
      }
    }
    img {
      width: 34px;
      height: 34px;
    }
  }
  .header-cover {
    width: 34px;
    height: 34px;
    margin-left: 5px;
  }
  .member1,
  .member2,
  .member3,
  .member4,
  .member5,
  .member6 {
    border-radius: 10px 10px 0px 0px;
  }
  .member1 {
    background: linear-gradient(0deg, #e6ffff, #b2fcfb);
  }
  .member2 {
    background: url(~@/images/member2.png);
  }
  .member3 {
    background: url(~@/images/member3.png);
  }
  .member4 {
    background: url(~@/images/member4.png);
  }
  .member5 {
    background: url(~@/images/member5.png);
  }
  .member6 {
    background: url(~@/images/member6.png);
  }
  .popover-content-list {
    height: 30px;
    display: flex;
    font-size: 12px;
    font-family: PingFang-SC-Regular;
    align-items: center;
    padding-left: 12px;
    .popover-content-text {
      color: #656565;
      span {
        color: #333333;
      }
    }
  }

  .content-bind-btn {
    font-size: 12px;
    color: #fe5200;
    padding-left: 5px;
    cursor: pointer;
    font-family: PingFang-SC-Regular;
  }

  .popover-btn-box {
    display: flex;
    border-top: 1px solid rgba(235, 235, 235, 1);
    margin-top: 5px;
    font-family: PingFang-SC-Regular;
    font-size: 12px;
  }

  .popover-btn {
    cursor: pointer;
    color: #919191;
    // height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;
    flex: 1;
    margin-top: 15px;
    margin-bottom: 5px;
  }

  .popover-mobile-icon {
    margin-right: 10px;
  }

  .popover-icon {
    margin-right: 10px;
  }

  .popover-btn:hover {
    /*background:rgba(242,250,255,1);*/
    color: #666;
  }
}
.phone-text {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-family: PingFang-SC-Regular;
  cursor: pointer;
}
.memberIconInfo {
  display: flex;
  align-items: center;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  img {
    margin-right: 2px;
    width: 19px;
    height: 17px;
  }
  .color1 {
    color: #00ceff;
  }
  .color2 {
    color: #07e6e1;
  }
  .color3 {
    color: #ffab59;
  }
  .color4 {
    color: #c121ff;
  }
  .color5 {
    color: #ff2030;
  }
  .color6 {
    color: #af7608;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerPay.vue